export default __webpack_public_path__ + "static/media/white_logo_with_text.3fec17f2.png";